import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../common/services/base-crud.service';
import { environment } from '../../../environments/environment';
import { User, UserFCMBody, UserForm } from './models/user.model';
import { ApiItemResponse } from '../../common/models/api';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UsersService extends BaseCrudService<User, User, UserForm> {
  protected resource = 'users';
  protected apiRoot = environment.baseUrl;
  baseUrl: string = `${environment.baseUrl}`;

  assignRoles(
    userId: string,
    roleIds: string[],
  ): Observable<ApiItemResponse<any>> {
    try {
      return this.http.post<ApiItemResponse<any>>(
        `${this.apiRoot}/${this.resource}/${userId}/roles`,
        {
          roleIds,
        },
      );
    } catch (err) {
      console.log(err);
    }
  }

  updateFCMToken(
    id: string,
    payload: Partial<UserFCMBody>,
  ): Observable<ApiItemResponse<any>> {
    try {
      return this.http.patch<ApiItemResponse<any>>(
        `${this.apiRoot}/${this.resource}/fcm/${id}`,
        payload,
      );
    } catch (err) {
      console.log(err);
    }
  }

  callUser(payload: {
    callee: string;
    calleePhone?: string;
  }): Observable<ApiItemResponse<any>> {
    return this.http.post<ApiItemResponse<any>>(
      `${this.apiRoot}/call`,
      payload,
    );
  }
}
